var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"titlebtn",on:{"click":_vm.click}},[(_vm.type === 'min')?_c('span',{style:(_vm.style)},[_vm._v("━")]):(_vm.type === 'max')?_c('span',{style:(_vm.style)},[_vm._v("▢")]):(_vm.type === 'close')?_c('span',{staticClass:"title-text",style:(_vm.style)},[_vm._v(" ╳ ")]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }